import React from 'react';
import { Helmet } from 'react-helmet';

import fourStepHook from 'hooks/four-steps/four-steps.hook';

const FourStepsRichSnippet = (): JSX.Element => {
  const steps = fourStepHook();
  const schemaNode = steps[0].node;

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org/',
          '@type': 'HowTo',
          name: schemaNode.name,
          description: schemaNode.content,
          image: schemaNode.image.data.full_url,
          step: steps.slice(1).map(({ node }) => ({
            '@type': 'HowToStep',
            image: node.image.data.full_url,
            text: node.content,
            name: node.name,
            url: 'https://www.rapidformations.co.uk/',
          })),
        })}
      </script>
    </Helmet>
  );
};

export default FourStepsRichSnippet;
